import { useState } from "react";
import AuthLayout from "../../blocs/AuthLayout";
import TextInput from "../../components/inputs/TextInuput";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { isValidEmail } from "../../utils/utils";

const StepOneReset = () => {
  const [email, setEmail] = useState(null);
  const navigate=useNavigate()
  const sendCode=async()=>{
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}forgot-password`,
        {
          email,
        }
      );
      navigate("/sendCode", {state:{email}}); // Redirect to the profile page
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Échec de la connexion";
        toast.error(errorMessage);
    }
  }
  return (
    <>
      <AuthLayout
        image="../images/prestaLeftImg.png"
        title="Réservez tous vos <strong>services pros </strong>, quand et où vous voulez."
      >
        <div className="col-md-8 mx-auto">
          <h3 className="grey500 text-center">Mot de passe oublié</h3>
          <p className="body grey66 mt-16">
          Confirmez votre e-mail et nous vous enverrons
           un code pour réinitialiser votre mot de passe.{" "}
          </p>
          <TextInput
            label="Email"
            required
            type="email"
            placeholder="Adresse e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" onClick={sendCode} disabled={!isValidEmail(email)} className="twyny-cta-primary w-100 mt-24" >
            Suivant
          </button>
        </div>
      </AuthLayout>
    </>
  );
};
export default StepOneReset;
